import React, { useCallback, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Card, Col, Row } from 'react-bootstrap';
import Sidebar from "../../../components/Sidebar";
import Pagination from "../../../common/Pagination";
import { FacebookIcon, TwitterIcon, WhatsAppIcon } from "../../../components/Icons";
import CssLoader from '../../../components/cssloader/CssLoader';
import { categoryService } from "../../../services/CategoryService";
import { VideoItem } from "../../../helpers/interfaces/video";
import PageMeta from '../../../components/PageMeta';
import './Video.css';
import Advertising from "../../../common/Advertising";

export default function VideoPage() {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [videoData, setVideoData] = useState<VideoItem | null>(null);
    const pageLimit = 12;

    const fetchVideoData = useCallback(async (articleId: string) => {
        setIsLoading(true);

        try {
            const data = await categoryService.getVideoData(articleId)
            if (data) {
                setVideoData(data);
            }
        } catch (error) {
            console.error("Error fetching article data: ", error);
        } finally {
            setIsLoading(false);
        }
    }, []);


    useEffect(() => {
        if (id) {
            fetchVideoData(id);
        }
    }, [id, fetchVideoData]);

    const VideoCard = (props: { id: string, cards: VideoItem[] }) => {
        return (
            <Row className="content-width">
                {props.cards.map((card, index) => (
                    <React.Fragment key={card.id}>
                        {index % 6 === 0 && index !== 0 && (
                            <Advertising code="banner-cat5" as="div" />

                        )}
                        <Col key={`${props.id}_${card.id}`} md={4} className="">
                            <Card>
                                {card.video_id ? (
                                    <Link to={"/video/" + card.video_id} title={card.name}>
                                        <Card.Img variant="top" src={card.img} />
                                    </Link>
                                ) : (
                                    <Card.Img variant="top" src={card.img} />
                                )}
                                <Card.Body>
                                    <Link to={"/video/" + card.video_id} title={card.name}>
                                        <Card.Title>{card.name}</Card.Title>
                                        <Card.Text>{card.created_at}</Card.Text>
                                    </Link>
                                </Card.Body>
                            </Card>
                        </Col>
                    </React.Fragment>
                ))}
            </Row>
        );
    };

    const currentVideos = videoData?.relatedVideos && videoData?.relatedVideos.length > 0 ? videoData?.relatedVideos : [];

    const paginationVideos = [...currentVideos].splice(
        ((currentPage - 1) * pageLimit),
        pageLimit
    );

    return <React.Fragment>
        <PageMeta
            title={`${videoData?.name} – Calcio a 5 Live`}
            description={""}
            image={videoData?.img}
            url={document.location.href}
            type={"video.other"}
        />
        <Row id="page_content">
            <Col id="content" xs={12} lg={9}>
                <h1>{videoData?.name}</h1>
                <div className="video-center">
                    <div className="video-header">
                        {videoData?.img && (
                            <div className="image-container">
                                <iframe src={(
                                    videoData.type === 'YT'
                                        ? 'https://www.youtube.com/embed/'
                                        : 'https://www.facebook.com/video/embed?video_id='
                                ) + videoData.video_id} title={videoData?.name} />
                            </div>
                        )}

                        <div className="title-share">
                            <div className="title-container">
                                <div className="video-info">
                                    <p>
                                        <span>{videoData?.created_at}</span>
                                    </p>
                                    {
                                        videoData?.societa && videoData?.societa.length > 0 && <p>Società:
                                            {videoData?.societa.map((s) => (
                                                <li key={s.idSocieta}>
                                                    <ul>
                                                        <Link to={`/societa/${s.idSocieta}`}>{s.nomeSocieta}</Link>
                                                    </ul>
                                                </li>
                                            ))}

                                        </p>
                                    }
                                </div>
                            </div>

                            <div className="share-to-social-media">
                                <div className="social-media-actions">
                                    <a className="social-media-svg" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(document.location.href)}`} target="_blank" title="Facebook" rel="noopener noreferrer">
                                        <FacebookIcon />
                                    </a>
                                    <a className="social-media-svg" href={`https://api.whatsapp.com/send?text=${encodeURIComponent(document.location.href)}`} target="_blank" title="WhatsApp" rel="noopener noreferrer">
                                        <WhatsAppIcon />
                                    </a>
                                    <a className="social-media-svg" href={`https://twitter.com/share?url=${encodeURIComponent(document.location.href)}&text=${encodeURIComponent(videoData?.name ?? '')}`} target="_blank" title="Twitter" rel="noopener noreferrer">
                                        <TwitterIcon />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    currentVideos.length > 0 && <div className="related-videos">
                        <hr />
                        <Advertising code="banner-cat4" as="div" />
                        <h2 className="mt-2 mb-5">Potrebbe interessarti anche...</h2>
                        <VideoCard id="related_videos" cards={paginationVideos} />
                        <div className="d-flex justify-content-center">
                            <Pagination
                                totalRecords={currentVideos.length}
                                pageLimit={pageLimit}
                                pageNeighbours={2}
                                onPageChanged={setCurrentPage}
                                currentPage={currentPage}
                            />
                        </div>
                    </div>
                }

            </Col>
            <Col id="sidebar" xs={12} lg={3} className="pt-3">
                <Sidebar />
            </Col>
        </Row>

        <CssLoader active={isLoading} text="Caricamento del video in corso..." />
    </React.Fragment>
}
